(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationLogsDialogController', ApplicationLogsDialogController);

    ApplicationLogsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationLogs'];

    function ApplicationLogsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationLogs) {
        var vm = this;

        vm.applicationLogs = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.applicationLogs.id !== null) {
                ApplicationLogs.update(vm.applicationLogs, onSaveSuccess, onSaveError);
            } else {
                ApplicationLogs.save(vm.applicationLogs, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:applicationLogsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
